import React from 'react';

import FormRow from '../../../../components/common/forms/Row/FormRow';
import TextInputComponent from '../../../../components/common/forms/TextInput/TextInputComponent';
import PrimaryButton from '../../../../components/common/forms/Button/PrimaryButton';
import FormWrapper from '~/src/components/common/forms/FormWrapper/FormWrapper';

interface Props {
  formikProps: any;
}

export default function InventoryRemoveEditForm({ formikProps }: Props): JSX.Element {
  const { handleBlur, handleChange, values, touched, errors, handleSubmit, isSubmitting } = formikProps;
  return (
    <FormWrapper>
      <form onSubmit={handleSubmit} autoComplete="off">
        <FormRow>
          <TextInputComponent
            name="fullDuUnits"
            value={values.fullDuUnits}
            onBlur={handleBlur}
            onChange={handleChange}
            type="number"
            cols={12}
            touched={touched}
            errors={errors}
            label={`Available Full DU Units: ...`}
          />
        </FormRow>
        <FormRow>
          <TextInputComponent
            name="singleDpUnits"
            value={values.singleDpUnits}
            onBlur={handleBlur}
            onChange={handleChange}
            type="number"
            cols={12}
            touched={touched}
            errors={errors}
            label={`Available Single Display Units: ...`}
          />
        </FormRow>
        <FormRow>
          <TextInputComponent
            name="singleCuUnits"
            value={values.singleCuUnits}
            onBlur={handleBlur}
            onChange={handleChange}
            type="number"
            cols={12}
            touched={touched}
            errors={errors}
            label={`Available Single Units: ...`}
          />
        </FormRow>

        <FormRow>
          <PrimaryButton variant="primary" isSubmitting={isSubmitting} type="submit" title="Save" />
        </FormRow>
      </form>
    </FormWrapper>
  );
}
